import React from 'react';
import { motion } from 'framer-motion';
import { Menu } from 'lucide-react';

export default function PageContainer({ title, subtitle, children, toggleSidebar, actions }) {
  return (
    <motion.div
      className="page"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <div className="page-header-enhanced">
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <button className="mobile-menu-btn" onClick={toggleSidebar}>
            <Menu size={24} />
          </button>
          <div>
            <h1 className="page-title">{title}</h1>
            {subtitle && <p className="page-subtitle">{subtitle}</p>}
          </div>
        </div>
        <div className="header-actions">{actions}</div>
      </div>
      {children}
    </motion.div>
  );
}
